import type { DashboardResponseTypes } from "../common/response.common";
import { get } from "./common";

export const dashboard = {
    obtain() {
        return get<DashboardResponseTypes.Obtain>(`/dashboard/obtain`);
    },
};
